import React from 'react';
import Loader from './Loader';

const LoaderLayout = ({ isPending, children }) => <div>{isPending ? <Loader /> : children}</div>;

export default LoaderLayout;
